export const RETURN = 'Regresar';